var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 664 367",
    width: 664,
    height: 367,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 123.000,86.125 C 123.000,78.925 123.000,83.125 123.000,80.125",
    strokeWidth: 5.181,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 123.000,80.125 C 123.345,87.135 123.000,82.925 123.000,94.125",
    strokeWidth: 5.042,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 123.000,94.125 C 121.719,127.685 121.345,127.635 119.000,161.125",
    strokeWidth: 1.416,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 119.000,161.125 C 116.374,189.170 116.719,189.185 113.000,217.125",
    strokeWidth: 1.336,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 113.000,217.125 C 108.689,247.087 109.374,247.170 105.000,277.125",
    strokeWidth: 1.22,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 105.000,277.125 C 98.136,304.350 101.689,304.087 99.000,331.125",
    strokeWidth: 1.261,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 198.000,220.125 C 175.141,228.552 175.000,228.125 152.000,236.125",
    strokeWidth: 4.028,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 152.000,236.125 C 119.801,245.525 120.141,246.552 88.000,256.125",
    strokeWidth: 1.388,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 88.000,256.125 C 32.022,271.988 50.801,268.525 14.000,282.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.000,282.125 C 27.562,286.494 8.022,285.488 40.000,283.125",
    strokeWidth: 2.331,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 40.000,283.125 C 98.622,261.908 99.562,266.994 158.000,243.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 158.000,243.125 C 197.546,233.760 196.622,230.908 236.000,221.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 236.000,221.125 C 266.901,208.861 267.546,210.760 298.000,197.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 298.000,197.125 C 320.540,190.272 319.901,188.861 342.000,181.125",
    strokeWidth: 1.354,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 287.000,92.125 C 292.110,91.604 290.000,93.125 293.000,94.125",
    strokeWidth: 5.159,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 293.000,94.125 C 293.622,101.663 295.110,100.104 293.000,109.125",
    strokeWidth: 3.342,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 293.000,109.125 C 291.558,125.710 291.622,125.663 289.000,142.125",
    strokeWidth: 2.186,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 289.000,142.125 C 284.512,164.047 285.558,164.210 281.000,186.125",
    strokeWidth: 1.641,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.000,186.125 C 276.721,208.038 277.512,208.047 275.000,230.125",
    strokeWidth: 1.628,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 275.000,230.125 C 274.354,246.661 273.721,246.538 275.000,263.125",
    strokeWidth: 1.769,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 275.000,263.125 C 273.922,285.457 275.354,272.161 277.000,281.125",
    strokeWidth: 2.299,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 277.000,281.125 C 289.884,253.287 287.422,266.457 302.000,225.125",
    strokeWidth: 2.472,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 302.000,225.125 C 308.159,210.187 308.384,210.287 314.000,195.125",
    strokeWidth: 2.073,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 314.000,195.125 C 326.496,160.886 327.159,161.187 340.000,127.125",
    strokeWidth: 1.197,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 340.000,127.125 C 343.088,117.845 341.496,123.386 344.000,120.125",
    strokeWidth: 2.304,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 344.000,120.125 C 347.255,133.533 347.088,127.845 348.000,147.125",
    strokeWidth: 2.796,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 348.000,147.125 C 346.385,170.248 349.255,170.033 348.000,193.125",
    strokeWidth: 1.696,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 348.000,193.125 C 350.013,212.855 349.385,212.748 354.000,232.125",
    strokeWidth: 1.695,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 354.000,232.125 C 356.106,242.168 356.013,241.855 360.000,251.125",
    strokeWidth: 2.235,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 360.000,251.125 C 362.220,256.220 361.106,253.668 364.000,255.125",
    strokeWidth: 3.304,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 364.000,255.125 C 368.734,249.287 368.720,252.220 373.000,243.125",
    strokeWidth: 3.679,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 373.000,243.125 C 378.015,232.024 377.734,236.287 382.000,229.125",
    strokeWidth: 3.175,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 382.000,229.125 C 382.369,236.015 383.515,228.024 384.000,235.125",
    strokeWidth: 4.347,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 384.000,235.125 C 389.173,229.554 387.869,233.015 393.000,223.125",
    strokeWidth: 4.304,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 393.000,223.125 C 400.146,207.587 401.673,208.554 409.000,193.125",
    strokeWidth: 2.181,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 409.000,193.125 C 415.265,182.674 415.146,183.087 423.000,174.125",
    strokeWidth: 2.3,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 423.000,174.125 C 426.172,170.962 424.765,172.174 428.000,172.125",
    strokeWidth: 3.634,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 428.000,172.125 C 430.638,176.922 431.672,174.462 434.000,181.125",
    strokeWidth: 4.015,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 434.000,181.125 C 436.505,185.669 436.638,184.422 440.000,187.125",
    strokeWidth: 3.827,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 440.000,187.125 C 443.844,187.889 442.505,188.169 446.000,186.125",
    strokeWidth: 4.826,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 446.000,186.125 C 448.717,182.251 449.344,183.389 451.000,178.125",
    strokeWidth: 3.846,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 451.000,178.125 C 462.850,159.256 461.717,158.751 472.000,139.125",
    strokeWidth: 1.828,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 472.000,139.125 C 485.495,109.640 485.350,109.756 496.000,79.125",
    strokeWidth: 1.264,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 496.000,79.125 C 509.622,35.829 506.495,48.640 514.000,17.125",
    strokeWidth: 1.158,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 514.000,17.125 C 507.423,24.094 515.122,12.329 507.000,32.125",
    strokeWidth: 2.443,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 507.000,32.125 C 508.064,53.246 505.923,52.594 511.000,74.125",
    strokeWidth: 1.738,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 511.000,74.125 C 517.399,117.232 517.064,117.246 525.000,160.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 525.000,160.125 C 533.343,195.923 531.399,196.232 539.000,232.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 539.000,232.125 C 546.792,260.642 543.343,259.923 545.000,288.125",
    strokeWidth: 1.206,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 545.000,288.125 C 542.050,309.419 543.792,306.642 533.000,324.125",
    strokeWidth: 1.496,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 533.000,324.125 C 527.107,326.731 530.050,328.919 521.000,327.125",
    strokeWidth: 2.374,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 521.000,327.125 C 510.884,328.960 511.607,327.731 502.000,326.125",
    strokeWidth: 2.508,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 502.000,326.125 C 487.372,320.191 487.384,321.460 474.000,312.125",
    strokeWidth: 2.051,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 474.000,312.125 C 455.597,301.211 455.872,301.191 439.000,288.125",
    strokeWidth: 1.72,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.000,288.125 C 430.500,279.625 429.597,280.711 422.000,271.125",
    strokeWidth: 2.058,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 422.000,271.125 C 415.953,267.755 420.000,269.125 418.000,267.125",
    strokeWidth: 3.209,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 418.000,267.125 C 433.027,265.316 428.953,263.755 448.000,263.125",
    strokeWidth: 3.012,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 448.000,263.125 C 474.121,259.777 474.027,259.316 500.000,255.125",
    strokeWidth: 1.701,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 500.000,255.125 C 519.168,252.967 518.621,251.777 537.000,247.125",
    strokeWidth: 1.68,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 537.000,247.125 C 550.106,244.413 548.168,243.467 558.000,236.125",
    strokeWidth: 2.098,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 558.000,236.125 C 568.379,221.099 570.106,223.413 577.000,205.125",
    strokeWidth: 1.818,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 577.000,205.125 C 585.816,189.615 585.379,189.599 592.000,173.125",
    strokeWidth: 1.873,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 592.000,173.125 C 596.891,157.219 597.816,157.615 601.000,141.125",
    strokeWidth: 1.841,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 601.000,141.125 C 600.612,131.884 602.891,133.719 604.000,126.125",
    strokeWidth: 2.504,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 604.000,126.125 C 607.437,124.673 605.612,123.384 611.000,124.125",
    strokeWidth: 3.806,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 611.000,124.125 C 614.112,124.744 613.937,123.673 617.000,124.125",
    strokeWidth: 4.667,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 617.000,124.125 C 620.911,122.293 621.112,123.244 625.000,121.125",
    strokeWidth: 3.98,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 625.000,121.125 C 627.978,120.357 627.911,120.293 631.000,120.125",
    strokeWidth: 4.046,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 631.000,120.125 C 634.518,120.374 634.478,119.857 638.000,120.125",
    strokeWidth: 4.629,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    cx: 126,
    cy: 59.125,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.e011a3f4ccf4dec170af6256f07b8b59.svg";
export { ForwardRef as ReactComponent };